// Alpine $store('navCollapsed') — persists nav section state per tenant and user.
// The server-side gate determines whether the toggle buttons are shown.

document.addEventListener('alpine:init', () => {
  const sidebar = document.querySelector('[data-app-sidebar]');
  const scope = sidebar?.dataset.navStorageScope;
  const STORAGE_KEY = scope ? `navCollapsedSections:${scope}` : null;
  let saved = {};
  try { saved = STORAGE_KEY ? JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}') || {} : {}; } catch {}

  window.Alpine.store('navCollapsed', {
    state: { ...saved },
    toggle(key) {
      this.state = { ...this.state, [key]: !this.state[key] };
      try { if (STORAGE_KEY) localStorage.setItem(STORAGE_KEY, JSON.stringify(this.state)); } catch {}
    },
    isCollapsed(key) {
      return !!this.state[key];
    },
  });
});
